/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_Auth_LogoutInputs */

const cs_audit_key_auth_logout = /** @type {(inputs: Audit_Key_Auth_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uživatel odhlášen`)
};

const en_audit_key_auth_logout = /** @type {(inputs: Audit_Key_Auth_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User logged out`)
};

/**
* | output |
* | --- |
* | "User logged out" |
*
* @param {Audit_Key_Auth_LogoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_auth_logout = /** @type {((inputs?: Audit_Key_Auth_LogoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_Auth_LogoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_auth_logout(inputs)
	return cs_audit_key_auth_logout(inputs)
});